<template>
  <span>
    <v-autocomplete dense v-bind:value="value" :disabled="disabled" :auto-select-first="autoSelectFirst"
      v-on:input="onInput" :rules="rules" :items="data.items" :loading="data.isLoading" :search-input.sync="data.search"
      item-text="label" item-value="code" no-data :no-data-text="'- type to find -'" clearable @focus="onFocus"
      @change="onInput" :no-filter="true" return-object multiple :required="required" :hint="hint"
      :persistent-hint="hint ? true : false" :placeholder="placeholder" flat hide-details></v-autocomplete>
  </span>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {debounce} from "./../../../libs/debounce"
import eventBus from "../../../eventBus"
import {thermalService} from "./service"
import {rules} from "./../../../libs/utils"

@Component({
  components: {},
})
export default class ThermalSelect extends Vue {
  @Prop({default: () => []})
  rules

  @Prop()
  canton //filter locations by canton
  @Prop({default: false})
  autoSelectFirst

  @Prop({default: false})
  allowNew

  @Prop()
  value

  @Prop()
  required

  @Prop()
  disabled

  @Prop({default: "Thermal"})
  label

  @Prop({default: null})
  hint

  @Prop()
  siteID

  @Prop()
  placeholder

  data: any = {
    items: [],
    isLoading: false,
    search: null,
    canton: null,
  }

  async created() {
    this.data.canton = this.canton
    if (this.value && this.value.length > 0) {
      Vue.set(this.data, "items", this.value)
    }
  }

  onInput(val) {
    this.$emit("input", val)
  }

  async onFocus() {
    this.loadItems()
  }

  @Watch("canton")
  onCantonSet(val) {
    console.log("set canton", val)
    this.data.canton = val
    this.loadItems()
  }

  @Watch("value")
  onValueSet(val) {
    // if (val) {
    //   Vue.set(this.data, "items", [val])
    // }
  }

  @Watch("data.search")
  find(val) {
    debounce.delay(() => {
      this.loadItems()
    }, 450)
  }

  async loadItems() {
    if (this.data.isLoading) {
      return
    }
    this.data.isLoading = true
    let payload = {
      q: this.data.search,
      canton: this.canton ? this.canton.code : null,
    }
    try {
      let options = {fields: "code,canton,lang", limit: 25}
      let res = await thermalService.find(payload, options)
      if (res.error == true || res.data == null) {
        eventBus.$emit("display-snackbar", {type: "error", text: "Failed to load items. Please check your internet connection and try again"})
        this.data.isLoading = false
        return
      }

      let langcode = localStorage.getItem("user-language")
      let kangAsKey = langcode ? String(langcode) : ""
      if (kangAsKey) {
        res.data.forEach((item) => {
          item.label = item.lang?.[kangAsKey] ?? item.code
        })
        this.data.items = res.data
      } else {
        this.data.items = res.data.map((item) => {
          return {
            code: item.code,
            label: item.code,
          }
        })
      }
      this.data.isLoading = false
    } catch (error) {
      console.log(error)
      this.data.isLoading = false
    }
  }
}
</script>
